var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SelectFolderModal',{ref:"selectFolderModal",attrs:{"modal-id":"feed-import-file-browser-modal","modal-title":"Select Excel feed file","view-tabs":false,"show-layouts":false,"is-light-weight":true},on:{"onSelectedItems":_vm.handleSelectedItems}})
}
var staticRenderFns = []

export { render, staticRenderFns }